import {useLocation, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import refreshIcon from '../../../../media/shared-access/ic-refresh.svg'
import markReadIcon from '../../../../media/shared-access/ic-mark-read.svg'
import deleteIcon from '../../../../media/shared-access/ic-delete.svg'
import starIcon from '../../../../media/shared-access/ic-star.svg'
import starActiveIcon from '../../../../media/shared-access/ic-star-active.svg'
import {DateTime} from 'luxon'
import {Form, Pagination} from 'react-bootstrap'
// import clsx from 'clsx'
import {deleteEmails, markedRead, markedStarred} from '../core/_requests'
import {toast} from 'react-toastify'
import {useAuth} from '../../auth'
import '../style/inboxdetails.scss'
import {ConfirmationModal} from './ConfirmationModal'
import Skeleton from 'react-loading-skeleton'
import {NoDataPage} from '../../resources/components/NoDataPage'
import searchIcon from '../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import TagManager from 'react-gtm-module'
import {GTMEvent} from '../../../hooks/gtmHelpers'

export const InboxList = ({
  emails,
  currentPage,
  setCurrentPage,
  status,
  emailPerPage,
  count,
  pageNumbers,
  totalRecords,
  setEmailPerPage,
  search,
  setSearch,
  setStarredEmails,
  starredEmails,
  getAllMails,
  inboxListLoading,
  userLoading,
  connectorLoading,
}: any) => {
  const {formatMessage} = useIntl()
  const location = useLocation()
  const navigate = useNavigate()
  const [selectedEmails, setSelectedEmails] = useState<string[]>([])
  const [selectAll, setSelectAll] = useState(false)
  const {companyId, currentUser} = useAuth()
  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [isDeleting, setIsDeleting] = useState<boolean>(false)

  const handleEmailClick = (emailId: any, emailStatus: any) => {
    console.log(emailStatus, ' sfsf')
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('id', emailId)
    if (status === 'INBOX') {
      markedAsRead(emailId)
    }
    if (emailStatus === 'DRAFT' && status === 'TRASH') {
      const pathname = location.pathname
      searchParams.delete('status')
      searchParams.set('status', 'draft')
      searchParams.set('isDeleted', 'true')
      navigate(`${pathname}?${searchParams.toString()}`)
    } else {
      navigate(`${location.pathname}?${searchParams.toString()}`)
    }
  }
  const handleCheckboxChange = (emailId: string) => {
    setSelectedEmails(
      (prevSelectedEmails) =>
        prevSelectedEmails.includes(emailId)
          ? prevSelectedEmails.filter((id) => id !== emailId)
          : [...prevSelectedEmails, emailId] //
    )
  }
  const formatTime = (time: string) => {
    const dateTime = DateTime.fromISO(time)
    const now = DateTime.now()

    if (dateTime.hasSame(now, 'day')) {
      return dateTime.toFormat('h:mm a') // Format as '8:30 PM' or '8:30 AM'
    } else if (dateTime.hasSame(now.minus({days: 1}), 'day')) {
      return 'Yesterday'
    } else {
      const diffInDays = Math.floor(now.diff(dateTime, 'days').days)

      if (diffInDays < 30) {
        return `${diffInDays} days ago`
      } else {
        const diffInMonths = Math.floor(now.diff(dateTime, 'months').months)
        return `${diffInMonths} month${diffInMonths > 1 ? 's' : ''} ago`
      }
    }
  }

  const getPlaceholderText = (status: string) => {
    switch (status) {
      case 'INBOX':
        return formatMessage({id: 'Search inbox'})
      case 'SENT':
        return formatMessage({id: 'Search sent items'})
      case 'DRAFT':
        return formatMessage({id: 'Search drafts'})
      case 'TRASH':
        return formatMessage({id: 'Search trash'})
      case 'STARRED':
        return formatMessage({id: 'Search marked items'})
      default:
        return formatMessage({id: 'Search inbox'})
    }
  }

  const handleEmailsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setEmailPerPage(Number(event.target.value))
    setCurrentPage(1)
  }
  const handleSelectAllChange = () => {
    setSelectAll(!selectAll)
    if (!selectAll) {
      setSelectedEmails(emails.map((email: any) => email.emailMessageId))
    } else {
      setSelectedEmails([])
    }
  }
  useEffect(() => {
    if (selectedEmails.length === emails.length && emails.length > 0) {
      setSelectAll(true)
    } else {
      setSelectAll(false)
    }
  }, [selectedEmails, emails])

  const deleteMails = async () => {
    setIsDeleting(true)
    try {
      let payload = {
        isDraft: status === 'DRAFT' ? true : false,
        ids: selectedEmails,
      }
      const {
        data: {success, error},
      } = await deleteEmails(companyId!, payload)
      if (success) {
        setModalOpen(false)
        getAllMails()
        setSelectedEmails([])
        toast.success(formatMessage({id: 'Email deleted successfully'}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeleteSuccessful,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: error}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailDeleteFailed,
            action: 'normal',
            metadata: {
              email_ids: selectedEmails,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: error,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailDeleteFailed,
          action: 'normal',
          metadata: {
            email_ids: selectedEmails,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    } finally {
      setIsDeleting(false)
    }
  }

  const markedStar = async (emailId: string) => {
    const isStarred = starredEmails[emailId] || false

    // Toggle the starred status
    setStarredEmails((prev: any) => ({
      ...prev,
      [emailId]: !isStarred,
    }))

    try {
      const payload = {starred: !isStarred}
      const {
        data: {success, error, data},
      } = await markedStarred(companyId!, emailId!, payload)
      if (success) {
        console.log(data, ' marked')
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailStarredSuccessful,
            action: 'normal',
            metadata: {
              email_id: emailId,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      } else {
        toast.error(formatMessage({id: error}))
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.SharedAccessEmailStarredFailed,
            action: 'normal',
            metadata: {
              email_id: emailId,
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              error: error,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.SharedAccessEmailStarredFailed,
          action: 'normal',
          metadata: {
            email_id: emailId,
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            error: err,
          },
        },
      })
    }
  }
  const markedAsRead = async (emailId?: any) => {
    try {
      let payload = {
        ids: emailId ? [emailId] : selectedEmails,
      }
      console.log(payload, ' payload star')
      const {
        data: {success, error, data},
      } = await markedRead(companyId!, payload)
      if (success) {
        console.log(data, ' marked')
        setSelectedEmails([])
        getAllMails()
      } else {
        toast.error(formatMessage({id: error}))
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      <div className='card'>
        <div className='card-header align-items-center py-5 gap-2 gap-md-5'>
          {inboxListLoading || userLoading || connectorLoading ? (
            <div className='w-25'>
              <Skeleton
                height={40}
                baseColor='var(--kt-skeleton-bg-color)'
                highlightColor='var(--kt-skeleton-highlight-bg-color)'
              />
            </div>
          ) : (
            <div className='d-flex flex-wrap gap-2'>
              {status !== 'TRASH' && (
                <>
                  <div className='form-check form-check-sm form-check-custom me-4 me-lg-7'>
                    <input
                      className='form-check-input'
                      type='checkbox'
                      data-kt-check='true'
                      data-kt-check-target='#kt_inbox_listing .form-check-input'
                      value='1'
                      checked={selectAll}
                      onChange={handleSelectAllChange}
                    />
                  </div>
                  <div
                    className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                    data-bs-toggle='tooltip'
                    data-bs-dismiss='click'
                    data-bs-placement='top'
                    title='Delete'
                    onClick={() => setModalOpen(true)}
                  >
                    <img className='inbox-prev-next-logo' src={deleteIcon} alt='' />
                  </div>
                </>
              )}

              <div
                className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                data-bs-toggle='tooltip'
                data-bs-dismiss='click'
                data-bs-placement='top'
                title='mark read'
                onClick={() => {
                  if (status === 'INBOX') {
                    markedAsRead()
                  }
                }}
              >
                <img className='inbox-prev-next-logo' src={markReadIcon} alt='' />
              </div>
              <div
                className='btn btn-sm btn-icon btn-light btn-active-light-primary'
                data-bs-toggle='tooltip'
                data-bs-dismiss='click'
                data-bs-placement='top'
                title='refresh'
                onClick={() => getAllMails()}
              >
                <img className='inbox-prev-next-logo' src={refreshIcon} alt='' />
              </div>
            </div>
          )}

          <div className='d-flex align-items-center'>
            <form className='align-items-center d-flex position-relative w-100 w-md-auto'>
              <span className='svg-icon svg-icon-3 position-absolute ms-2'>
                <img src={searchIcon} alt='Search icon' />
              </span>
              <input
                type='text'
                data-kt-inbox-listing-filter='search'
                className='bg-body bg-light form-control form-control-flush ps-10 rounded-2 font-size-12 font-weight-400 py-3 border '
                placeholder={getPlaceholderText(status)}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </form>
          </div>
        </div>

        {emails.length === 0 ? (
          <NoDataPage />
        ) : (
          <>
            <div className=''>
              <table className='table table-hover table-row-dashed mb-0' id='kt_inbox_listing'>
                <thead className='d-none'>
                  <tr>
                    {status !== 'TRASH' && <th>{formatMessage({id: 'Checkbox'})}</th>}
                    {status !== 'TRASH' && <th>{formatMessage({id: 'Actions'})}</th>}
                    <th>{formatMessage({id: 'Author'})}</th>
                    {status === 'TRASH' && <th>{formatMessage({id: 'Status'})}</th>}
                    <th>{formatMessage({id: 'Title'})}</th>
                    <th>{formatMessage({id: 'Date'})}</th>
                  </tr>
                </thead>
                <tbody>
                  {inboxListLoading || userLoading || connectorLoading ? (
                    <tr>
                      <td className=''>
                        <Skeleton
                          height={50}
                          count={10}
                          className='mx-4'
                          baseColor='var(--kt-skeleton-bg-color)'
                          highlightColor='var(--kt-skeleton-highlight-bg-color)'
                        />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {emails &&
                        emails.map((email: any, index: any) => (
                          <tr key={index} className={email.unread === false ? 'bg-light' : ''}>
                            {status !== 'TRASH' && (
                              <td className='ps-4'>
                                <div className='form-check form-check-sm form-check-custom mt-3'>
                                  <input
                                    className='form-check-input'
                                    type='checkbox'
                                    value='1'
                                    checked={selectedEmails.includes(email.emailMessageId)}
                                    onChange={() => handleCheckboxChange(email.emailMessageId)}
                                  />
                                </div>
                              </td>
                            )}
                            {status !== 'TRASH' && (
                              <td className=''>
                                <div
                                  className='btn btn-icon btn-color-gray-500 btn-active-color-primary w-35px h-35px'
                                  data-bs-toggle='tooltip'
                                  data-bs-placement='right'
                                  title='Star'
                                >
                                  <button
                                    className='btn m-0 p-0 d-block'
                                    onClick={() => markedStar(email.emailMessageId)}
                                  >
                                    <img
                                      src={
                                        starredEmails[email.emailMessageId]
                                          ? starActiveIcon
                                          : starIcon
                                      }
                                      alt={
                                        starredEmails[email.emailMessageId]
                                          ? formatMessage({id: 'Checkmark Active'})
                                          : formatMessage({id: 'Checkmark'})
                                      }
                                      className='like'
                                    />
                                  </button>
                                </div>
                              </td>
                            )}

                            <td
                              className='cursor-pointer'
                              onClick={() => handleEmailClick(email.emailMessageId, email.status)}
                            >
                              <div className='d-flex align-items-center text-gray-900'>
                                <div className='symbol symbol-35px me-3'>
                                  <div className='symbol-label bg-light-danger'>
                                    <span className='text-danger'>
                                      {' '}
                                      {email.fromName
                                        ? email.fromName.charAt(0).toUpperCase()
                                        : email.fromEmail.charAt(0).toUpperCase()}
                                    </span>
                                  </div>
                                </div>
                                <span
                                  className={email.unread === false ? 'fw-normal' : 'fw-semibold'}
                                >
                                  {email.fromName
                                    ? email.fromName.length > 24
                                      ? `${email.fromName.slice(0, 24)}...`
                                      : email.fromName
                                    : email.fromEmail.length > 24
                                    ? `${email.fromEmail.slice(0, 24)}...`
                                    : email.fromEmail}
                                </span>
                              </div>
                            </td>
                            {status === 'TRASH' && (
                              <td
                                className='cursor-pointer pt-4'
                                onClick={() => handleEmailClick(email.emailMessageId, email.status)}
                              >
                                <div
                                  className={`p-2 badge ${
                                    email.status === 'INBOX'
                                      ? 'badge-light-success'
                                      : email.status === 'SENT'
                                      ? 'badge-light-primary'
                                      : 'badge-light-warning'
                                  }`}
                                >
                                  <span
                                    className={email.unread === false ? 'fw-normal' : 'fw-semibold'}
                                  >
                                    {email.status.charAt(0).toUpperCase() +
                                      email.status.slice(1).toLowerCase()}{' '}
                                  </span>
                                </div>
                              </td>
                            )}
                            <td
                              onClick={() => handleEmailClick(email.emailMessageId, email.status)}
                              className='cursor-pointer'
                            >
                              <div className='text-gray-900 gap-1 pt-2'>
                                <div className='text-gray-900'>
                                  <span
                                    className={email.unread === false ? 'fw-normal' : 'fw-bold'}
                                  >
                                    {email.subject
                                      ? email.subject.length > 70
                                        ? `${email.subject.slice(0, 70)}...`
                                        : email.subject
                                      : '(no subject)'}
                                  </span>
                                  <span className='fw-bold d-none d-md-inine'>-</span>
                                  <span className='d-none d-md-inine text-muted'>
                                    {formatMessage({
                                      id: 'Thank you for ordering UFC 240 Holloway vs Edgar Alternate camera angles...',
                                    })}
                                  </span>
                                </div>
                              </div>
                            </td>
                            <td
                              className='fs-7 cursor-pointer pe-3'
                              onClick={() => handleEmailClick(email.emailMessageId, email.status)}
                            >
                              <span className='fw-semibold'>{formatTime(email?.createdAt)}</span>
                            </td>
                          </tr>
                        ))}
                    </>
                  )}
                </tbody>
              </table>
              {/* Pagination Section */}
              <div className={`w-100 d-flex justify-content-between align-items-center p-4`}>
                <div className={`d-flex gap-2 w-100 align-items-center`}>
                  <Form.Select
                    aria-label='Default select example'
                    className='px-4 py-3 w-80px'
                    value={emailPerPage}
                    onChange={handleEmailsPerPageChange}
                  >
                    <option value='10'>{formatMessage({id: '10'})}</option>
                    <option value='20'>{formatMessage({id: '20'})}</option>
                    <option value='50'>{formatMessage({id: '50'})}</option>
                    <option value='100'>{formatMessage({id: '100'})}</option>
                  </Form.Select>
                  <span className='font-size-13'>
                    {`Showing ${(currentPage - 1) * emailPerPage + 1} to ${Math.min(
                      (currentPage - 1) * emailPerPage + 1 + emailPerPage - 1,
                      count
                    )} of ${count} records`}
                  </span>
                </div>
                <Pagination className='w-100 d-flex flex-end'>
                  <Pagination.First
                    key='first'
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(1)}
                  />
                  <Pagination.Prev
                    key='prev'
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((p: any) => p - 1)}
                  />
                  {pageNumbers.map((number: any) => (
                    <Pagination.Item
                      key={number}
                      active={number === currentPage}
                      onClick={() => setCurrentPage(number)}
                    >
                      {number}
                    </Pagination.Item>
                  ))}
                  {pageNumbers.length > 6 && (
                    <>
                      {currentPage < pageNumbers.length - 3 && <Pagination.Ellipsis />}
                      {currentPage >= pageNumbers.length - 3 && (
                        <Pagination.Item>{pageNumbers.length}</Pagination.Item>
                      )}
                    </>
                  )}
                  <Pagination.Next
                    key='next'
                    disabled={currentPage === pageNumbers.length}
                    onClick={() => setCurrentPage((p: any) => p + 1)}
                  />
                  <Pagination.Last
                    key='last'
                    disabled={currentPage === pageNumbers.length}
                    onClick={() => setCurrentPage(pageNumbers[pageNumbers.length - 1])}
                  />
                </Pagination>
              </div>
            </div>
          </>
        )}
      </div>
      <ConfirmationModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        deleteMails={deleteMails}
        isDeleting={isDeleting}
      />
    </>
  )
}
